import React, { useState } from 'react';
import { Box, Heading, Text, Button, VStack, Image } from '@chakra-ui/react';
import { useLocation, useNavigate } from 'react-router-dom';

// Rotas permitidas para acesso via celular
const MOBILE_ALLOWED_PATHS = [
  '/mobile',
  '/mobile/',
  '/mobile/checkin',
  '/mobile/welcome',
  '/admin-mobile-login',
  '/mobile/admin-success'
];

// Rotas permitidas para acesso administrativo
const ADMIN_ALLOWED_PATHS = [
  '/admin',
  '/admin/',
  '/admin-login',
  '/admin/login',
  '/admin/dashboard',
  '/admin/mensalistas',
  '/admin/barbeiros',
  '/admin/servicos',
  '/admin/produtos',
  '/admin/cortes',
  '/admin/pacotes',
  '/admin/sorteio',
  '/admin/sorteio-config',
  '/admin/agenda'
];

const DeviceVerification = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const currentPath = location.pathname;
  const [showBlockScreen] = useState(true);
  
  // Detectar se é um dispositivo móvel
  const isMobileDevice = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  
  // Verificar se o caminho atual é permitido para dispositivos móveis
  const isAllowedMobilePath = MOBILE_ALLOWED_PATHS.some(path => currentPath.startsWith(path));
  
  // Verificar se o caminho atual é permitido para acesso administrativo
  const isAllowedAdminPath = ADMIN_ALLOWED_PATHS.some(path => currentPath.startsWith(path));
  
  // Verificar se é um dispositivo móvel tentando acessar uma rota não permitida
  if (isMobileDevice && !isAllowedMobilePath && !isAllowedAdminPath && showBlockScreen) {
    // Mostrar tela de bloqueio com a logo da empresa
    return (
      <Box 
        height="100vh" 
        width="100%" 
        bg="black" 
        display="flex" 
        alignItems="center" 
        justifyContent="center"
        p={4}
      >
        <VStack spacing={6} maxW="400px" textAlign="center">
          <Image 
            src={require('../assets/Logo-Barber.png')} 
            alt="Logo Barbearia" 
            height="120px" 
            objectFit="contain" 
            mb={4}
          />
          <Heading color="yellow.400" size="lg">Acesso Restrito</Heading>
          <Text color="white" fontSize="md">
            Esta interface é exclusiva para o totem da Barbearia Freire.
          </Text>
          <Text color="white" fontSize="md">
            Para acessar pelo celular, utilize o QR Code disponível no totem ou acesse diretamente:
          </Text>
          <Button 
            colorScheme="yellow" 
            size="lg" 
            onClick={() => navigate('/mobile/checkin')}
            mt={4}
          >
            Acessar Versão Mobile
          </Button>
        </VStack>
      </Box>
    );
  }
  
  // Se não for um dispositivo móvel ou se for uma rota permitida, renderizar normalmente
  return children;

};

export default DeviceVerification;
